import { Spin } from "antd";

type Props = {
  isVisible?: boolean;
};

function ContentSpinner({ isVisible = true }: Props) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        zIndex: 10000,
      }}
    >
      <Spin size="large" />
    </div>
  );
}

export default ContentSpinner;
